export type AppMode = 'home' | 'play' | 'career' | 'builder';

export function appModeFromSearch(search = window.location.search): AppMode {
  const params = new URLSearchParams(search);
  if (params.get('editor') === 'true') return 'builder';
  const mode = params.get('mode');
  if (mode === 'play' || mode === 'career' || mode === 'builder') return mode;
  return 'home';
}

export function isEditorMode(search = window.location.search): boolean {
  return appModeFromSearch(search) === 'builder';
}

export function modeSearch(destination: Exclude<AppMode, 'home'>): string {
  return `?mode=${destination}`;
}
